import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=3fa55c8c&"
import script from "./FormDate.vue?vue&type=script&lang=ts&"
export * from "./FormDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports